import { render, staticRenderFns } from "./CreateDamage.vue?vue&type=template&id=12564866&scoped=true&"
import script from "./CreateDamage.vue?vue&type=script&lang=js&"
export * from "./CreateDamage.vue?vue&type=script&lang=js&"
import style0 from "./CreateDamage.vue?vue&type=style&index=0&id=12564866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12564866",
  null
  
)

export default component.exports